import SpaceY from '../../../components/SpaceY';
import { MAX_WIDTH_639PX } from '../../../utils/common';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';

const MissionSustainableTable = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  const missionVideoLink = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/mission/${
    isMobile ? 'mo' : 'pc'
  }_mission-header.mp4`;

  return (
    <div className="relative h-368px overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="h-full w-full object-cover"
      >
        <source src={missionVideoLink} />
      </video>
      <div className="absolute inset-0 bg-littleblack" />
      <div className="absolute inset-0 top-127px text-center font-bold text-white">
        <p className="font-body1">우리의 미션</p>
        <SpaceY height="9px" />
        <h1 style={{ fontSize: 34, lineHeight: '48px' }}>
          지속 가능한 식탁을
          <br />
          만듭니다
        </h1>
      </div>
    </div>
  );
};

export default MissionSustainableTable;
